import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/main.less';
import '@/styles/hover-min.css';

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

//路由跳转重复报错
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}
router.beforeEach((to, from, next) => {
	if (to.meta.content) {
		let head = document.getElementsByTagName('head');
        let meta = document.createElement('meta');
		document.querySelector("#keywords").setAttribute('content', to.meta.content.keywords)
		document.querySelector("#description").setAttribute('content', to.meta.content.description)
		meta.content = to.meta.content;
		head[0].appendChild(meta)
	}
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	next()
});


Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI);


Vue.config.productionTip = false;

// 修改标题名称
Vue.directive('title', {
    inserted: function(el, binding) {
        document.title = el.dataset.title
            // document.title = "好心理"
    }
})
new Vue({
    router,
    render: h => h(App)
}).$mount("#app");


